function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as i } from "react/jsx-runtime";
import * as r from "react";
import o from "classnames";
import { BaseTouchable as c } from "./touchable.js";
import { base as d } from "./icon-button.css-mistica.js";
const s = 24, b = (e, t, a, n, l)=>{
    const m = n ? `${n}px ${n}px` : "100% 100%";
    return {
        padding: 0,
        backgroundColor: a,
        backgroundImage: e ? `url(${e})` : "initial",
        backgroundSize: m,
        cursor: l ? "default" : "pointer",
        height: t,
        width: t,
        verticalAlign: "middle",
        textAlign: "center"
    };
}, u = (e)=>{
    const { icon: t , children: a  } = e, n = {
        className: e.className || "",
        disabled: e.disabled,
        style: e.style,
        trackingEvent: e.trackingEvent,
        "aria-live": e["aria-live"],
        dataAttributes: _object_spread({
            "component-name": "IconButton"
        }, e.dataAttributes)
    };
    return e.href ? /* @__PURE__ */ i(c, _object_spread_props(_object_spread({}, n), {
        href: e.href,
        newTab: e.newTab,
        "aria-label": e["aria-label"],
        children: !t && r.Children.only(a)
    })) : e.to ? /* @__PURE__ */ i(c, _object_spread_props(_object_spread({}, n), {
        to: e.to,
        fullPageOnWebView: e.fullPageOnWebView,
        replace: e.replace,
        "aria-label": e["aria-label"],
        children: !t && r.Children.only(a)
    })) : e.onPress ? /* @__PURE__ */ i(c, _object_spread_props(_object_spread({}, n), {
        onPress: (l)=>{
            l.stopPropagation(), e.onPress(l);
        },
        "aria-label": e["aria-label"],
        children: !t && r.Children.only(a)
    })) : /* @__PURE__ */ i(c, _object_spread_props(_object_spread({}, n), {
        maybe: !0,
        children: !t && r.Children.only(a)
    }));
}, h = (e)=>{
    const { icon: t , backgroundColor: a = "transparent" , iconSize: n , size: l = s  } = e;
    return /* @__PURE__ */ i(u, _object_spread_props(_object_spread({}, e), {
        className: o(d, e.className),
        style: _object_spread({}, b(t, l, a, n, e.disabled), e.style)
    }));
}, B = (e)=>{
    const { size: t = s , disabled: a  } = e;
    return /* @__PURE__ */ i(u, _object_spread_props(_object_spread({}, e), {
        className: o(d, e.className),
        style: {
            height: t,
            width: t,
            cursor: a ? "default" : "pointer",
            verticalAlign: "middle",
            textAlign: "center"
        }
    }));
}, w = h;
export { B as BaseIconButton, w as default };
